import useApi from './useApi';

const useRolesService = () => {
  const { api } = useApi();

  const getRoles = () => api({
    method: 'get',
    url: '/identity-access/v1/establishments/own/establishment-roles',
  });

  return {
    getRoles,
  };
};

export default useRolesService;
